import notifyError from '@/lib/notify-error';
import notifySuccess from '@/lib/notify-success';
import { findAccounts, removeAccount, updateAccount } from '@/services/account';

const usersGetters = {
  account(st, gt, rSt) {
    return rSt.auth.account;
  },
  accounts(st) {
    return st.accounts.map(account => ({
      id: account.id,
      name: account.name,
      email: account.email,
      role: account.role[0].name,
      createdAt: account.createdAt,
      status: account.status,
    }));
  },
  headers() {
    return [
      {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'name',
      },
      { text: 'E-mail', value: 'email', sortable: false },
      { text: 'Perfil', value: 'role', sortable: true },
      { text: 'Cadastrado', value: 'createdAt', sortable: true },
      { text: 'Status', value: 'status', sortable: true },
      { text: 'Ações', value: 'action', sortable: false },
    ];
  },
  footerProps() {
    return {
      itemsPerPageOptions: [10, 20, 40, 80],
      showFirstLastPage: true,
    };
  },
  totalAccounts(st) {
    return st.totalAccounts;
  },
  search(st) {
    return st.search;
  },
  loading(st) {
    return st.loading;
  },
  options(st) {
    return st.options;
  },
  deleteItem(st) {
    return st.deleteItem;
  },
  deleteDialog(st) {
    return st.deleteDialog;
  },
  blockItem(st) {
    return st.blockItem;
  },
  blockDialog(st) {
    return st.blockDialog;
  },
};

const mutations = {
  setAccounts(state, accounts) {
    state.accounts = accounts;
  },
  setTotalAccounts(state, total) {
    state.totalAccounts = total;
  },
  setSearch(state, search) {
    state.search = search;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setOptions(state, options) {
    state.options = options;
  },
  setDeleteDialog(state, dialog) {
    state.deleteDialog = dialog;
  },
  setDeleteItem(state, item) {
    state.deleteItem = item;
  },
  setBlockDialog(state, dialog) {
    state.blockDialog = dialog;
  },
  setBlockItem(state, item) {
    state.blockItem = item;
  },
};

const actions = {
  loadAccounts({ commit }, { filter }) {
    commit('setLoading', true);
    const settings = {
      include: 'role',
      ...filter,
    };
    return findAccounts(settings)
      .then((accounts) => {
        commit('setAccounts', accounts.items);
      })
      .catch(() => {
        commit('setLoading', false);
        notifyError();
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  onInputSearch({ commit, dispatch }, search) {
    commit('setSearch', search);
    if (search) {
      dispatch('loadAccounts', { filter: { where: { name: { ilike: `%${search}%` } } } });
    } else {
      dispatch('loadAccounts', {});
    }
  },
  onDeleteDialogInput({ commit }, dialog) {
    commit('setDeleteDialog', dialog);
  },
  onDeleteDialogOpen({ commit }, item) {
    commit('setDeleteDialog', true);
    commit('setDeleteItem', item);
  },
  onDelete({
    state, dispatch, commit, rootState,
  }) {
    if (state.deleteItem.id === rootState.auth.account.id) {
      return notifyError('Muita calma nessa hora.. Você não quer se deletar, não é mesmo?');
    }
    commit('setLoading', true);
    return removeAccount(state.deleteItem.id)
      .then(notifySuccess('Usuário deletado com sucesso'))
      .then(() => {
        dispatch('loadAccounts', { $event: state.options });
        commit('setDeleteDialog', false);
      })
      .catch(notifyError())
      .finally(() => {
        commit('setLoading', false);
      });
  },
  onBlockDialogInput({ commit }, dialog) {
    commit('setBlockDialog', dialog);
  },
  onBlockDialogOpen({ commit }, item) {
    commit('setBlockDialog', true);
    commit('setBlockItem', item);
  },
  onBlock({ state, commit, rootState }) {
    if (state.blockItem.id === rootState.auth.account.id) {
      return notifyError('Muita calma nessa hora.. Você não pode se bloquear, não é mesmo?');
    }
    commit('setLoading', true);
    const payload = state.blockItem;
    payload.status = !payload.status;
    return updateAccount(payload)
      .then(notifySuccess('Ação realizada com sucesso'))
      .then((acc) => {
        commit('setBlockDialog', false);
        return acc;
      })
      .catch(notifyError())
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

export default {
  namespaced: true,
  state: {
    account: {},
    accounts: [],
    totalAccounts: 0,
    loading: true,
    options: {
      itemsPerPage: 10,
      page: 1,
      sortBy: [],
    },
    search: null,
    deleteDialog: false,
    deleteItem: {},
    blockDialog: false,
    blockItem: {},
  },
  mutations,
  getters: usersGetters,
  actions,
};
